
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 5.151a.9.9 0 011 0l8.1 5.4c.74.494.39 1.65-.5 1.65l-1.35-.001v8.1h1.35a.9.9 0 01.105 1.794l-.105.006H5.9a.9.9 0 01-.105-1.794L5.9 20.3h1.35v-8.1H5.9c-.854 0-1.21-1.06-.586-1.584l.087-.065zm-.4 7.049H9.05v8.1h4.05v-8.1zm5.85 0H14.9v8.1h4.05v-8.1zM14 6.982l-5.087 3.39a.9.9 0 01.016.027l10.198.001L14 6.982z"}})])
          )
        }
      }
    